import { gql } from "@apollo/client";

export const QUERY_PROCESSED_SESSION_DATA_AND_V2_MERGED = gql`
  query getProcessedSessionDataAndV2Merged($sessionId: String!) {
    getProcessedSessionDataAndV2Merged(sessionId: $sessionId) {
      processedSessionData {
        attackStatusByDriverLapLoop
        attackActivationsByDriver
        lapStartTimes
        flagStartTimes {
          dayTime
          flag
        }
        cautionLaps {
          lap
          type
        }
        lapStartTimesByDriver
        driverNamesByNumber
        sessionName
      }
      v2Merged {
        timing
        weather
        raceControl
        FiaFormulaE
        signalling
        rgps
      }
    }
  }
`;

export const QUERY_AVAILABLE_REPLAY_SEASONS = gql`
  query getAvailableReplaySeasons {
    getAvailableReplaySeasons
  }
`;

export const QUERY_REPLAY_EVENTS_FOR_SEASON = gql`
  query getReplayEventsForSeason($season: Float!) {
    getReplayEventsForSeason(season: $season) {
      eventName
      latestDt
    }
  }
`;

export const QUERY_REPLAY_SESSIONS_FOR_EVENT = gql`
  query getReplaySessionsForEvent($season: Float!, $eventName: String!) {
    getReplaySessionsForEvent(season: $season, eventName: $eventName) {
      sessionId
      eventName
      season
      dt
      sessionName
      isReal
    }
  }
`;

export const MUTATE_SET_REPLAY_SESSION_IS_REAL = gql`
  mutation setReplaySessionIsReal($sessionId: String!, $isReal: Boolean!) {
    setReplaySessionIsReal(sessionId: $sessionId, isReal: $isReal)
  }
`;

export const MUTATE_START_REPLAY = gql`
  mutation startReplay($params: ReplayParamsInput!) {
    startReplay(params: $params)
  }
`;

export const MUTATE_STOP_REPLAY = gql`
  mutation stopReplay {
    stopReplay
  }
`;

export const QUERY_CURRENT_REPLAY_STATE = gql`
  query getCurrentReplayState {
    getCurrentReplayState {
      connected
      params {
        sessionId
        timeSkip
        skipPreGreenLive
        skipNonRealTimeLive
      }
      playing
      loadingReplay
      replayStartTime
      processedSessionData {
        attackStatusByDriverLapLoop
        attackActivationsByDriver
        lapStartTimes
        flagStartTimes {
          dayTime
          flag
        }
        cautionLaps {
          lap
          type
        }
        lapStartTimesByDriver
        driverNamesByNumber
        sessionName
      }
    }
  }
`;

export const SUBSCRIBE_REPLAY_STATE_UPDATE = gql`
  subscription newReplayStateUpdate {
    newReplayStateUpdate {
      connected
      params {
        sessionId
        timeSkip
        skipPreGreenLive
        skipNonRealTimeLive
      }
      playing
      loadingReplay
      replayStartTime
      processedSessionData {
        attackStatusByDriverLapLoop
        attackActivationsByDriver
        lapStartTimes
        flagStartTimes {
          dayTime
          flag
        }
        cautionLaps {
          lap
          type
        }
        lapStartTimesByDriver
        driverNamesByNumber
        sessionName
      }
    }
  }
`;
